import React, { useEffect, useState } from 'react';
import {
  SurveyWindowContainer,
  SurveyWindowContent,
  SurveyWindowHead,
  SurveyWindowBody,
  SurveyWindowBodyIcon,
  SurveyWindowBodyLabel,
  SurveyWindowBodyDescription,
  SurveyWindowFooter,
  SurveyWindowFooterButton,
} from './styles';
import SurveyRadioButtons from '../SurveyRadioButtons';
import { IoClose } from 'react-icons/io5';
import colors from '../../assets/styles/colors';

const SurveyWindow = ({ step, question, idQuestion, show, actionNext, textNext = "siguiente", open, maxValue, minValue}) => {
  const [continuar, setContinuar] = useState(false);
  const [score, setScore] = useState(1);

  function onChangeSurveyScore (value) {
    setContinuar(true);
    console.log(value);
    setScore(value);
  }

  return (
    <SurveyWindowContainer open={open} id="survey-window">
      <SurveyWindowContent>
        <SurveyWindowBody>
          <SurveyWindowBodyLabel>
            {question}
          </SurveyWindowBodyLabel>
          <SurveyRadioButtons clickFunction={onChangeSurveyScore} id="survey-radio-button" maxValue={maxValue} minValue={minValue}/>
        </SurveyWindowBody>
        <SurveyWindowFooter>
          <SurveyWindowFooterButton onClick={() => actionNext(idQuestion, score)} id="bottom-action-button" disabled={!continuar}>
            {textNext}
          </SurveyWindowFooterButton>
        </SurveyWindowFooter>
      </SurveyWindowContent>
    </SurveyWindowContainer>
  )
}

export default SurveyWindow
